angular.module('app')
.config(function($httpProvider) {
    $httpProvider.interceptors.push(function($q, $injector) {
        var specificallyHandleInProgress = false;
        return {            
            responseError: function(response) {
                if(response.config && response.config.ignorarCatchInterceptor) return $q.reject(response);

                var $log = $injector.get('$log');                    
                switch (response.status) {
                    case -1:
                        //A requisição foi cancelada..
                    break;
                    case 401:
                        //requisição inválida
                        alert('A sua sessão expirou. Efetue login novamente para acessar o sistema.');
                        window.location.href="login";
                    break;   
                    case 403:
                        //acesso negado
                        var msg = response.data.error;
                        $log.error(msg, response);
                        $.gritter.add({
                            title: 'Acesso negado',
                            text: msg,
                            time: 10000,
                            class_name: 'erro'
                        });
                    break;                 
                    case 422:
                        //entidade não processada - erros de validação 
                        var erros = '';

                        var msg = response.data.mensagem ? response.data.mensagem : response.data.msg;

                        if (typeof response.data != 'string' && typeof msg!='string') {
                            angular.forEach(response.data, function(value) {
                                for (var j = 0; j < value.length; j++) {
                                    erros += value[j] + '<br>';
                                }
                            });
                        } else {
                            erros += msg ? msg : response.data;
                        }     
                        
                        $.gritter.add({
                            title: 'Erro ao processar requisição',
                            text: erros,
                            time: 10000,
                            class_name: 'erro'
                        });

                        break;
                    default:
                        //erro interno no servidor
                        var msg = 'Erro '+response.status+': '+response.statusText;
                        $log.error(msg, response);
                        $.gritter.add({
                            title: 'Erro ao processar requisição',
                            text: msg,
                            time: 10000,
                            class_name: 'erro'
                        });
                    break;
                }                
                return $q.reject(response);
            }
        };
    });
});